import React, {Component} from 'react';
import {StickyContainer, Sticky} from 'react-sticky';

export default class TheModernMarketer extends Component {
    render(){
        const {isMobile} = this.props;
        const iPhoneImg = require('images/brand_ambassadors/modern_marketer_iphone_mobile.png');
        const style = {
            position: 'absolute',
            width: '100%',
            height: 'inherit',
            left: '0px',
            margin: '0',
            padding: '0'
        };

        if(isMobile){
            return(
                <div className='gr-12 the-modern-marketer'>
                    <div className='the-modern-marketer-img-mobile'>
                        <img src={iPhoneImg} />
                    </div>
                    <div className='gr-5 push-1 the-modern-marketer-text'>
                        <h1>The modern marketer</h1>
                        <p>Social media has caused a fundamental shift in the way people connect. To remain relevant, brands must change the way they communicate. Social Native leverages the power of social ambassadors to create the authentic content brands need to build trust, maximize awareness, and boost sales.</p>
                    </div>
                </div>
            );
        } else {
            return(
                <StickyContainer className='gr-12 the-modern-marketer'>
                    <div className='gr-12 brand-ambassadors-hero'>
                        <Sticky
                            className='brand-ambassadors-hero-image'
                            stickyStyle={style}
                            stickyClassName={'stuck'}
                            isActive={true}
                            topOffset={5}
                            bottomOffset={0} />
                    </div>

                    <div className='row'>
                        <div className='gr-5 push-1 the-modern-marketer-text'>
                            <h1>The modern marketer</h1>
                            <p>Social media has caused a fundamental shift in the way people connect. To remain relevant, brands must change the way they communicate. Social Native leverages the power of social ambassadors to create the authentic content brands need to build trust, maximize awareness, and boost sales.</p>
                        </div>
                    </div>
                </StickyContainer>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/components/brand_ambassadors/the_modern_marketer.js